  // Function to format phone number
  export const formatPhoneNumber = (value) => {
    // Remove non-numeric characters
    const phoneNumber = value.replace(/\D/g, '').slice(0, 10);

    // Check if the number length is greater than 10
    if (phoneNumber.length > 10) return phoneNumber;

    // Format the number
    const areaCode = phoneNumber.slice(0, 3);
    const centralOfficeCode = phoneNumber.slice(3, 6);
    const lineNumber = phoneNumber.slice(6, 10);

    if (phoneNumber.length <= 3) return `(${areaCode}`;
    if (phoneNumber.length <= 6) return `(${areaCode}) ${centralOfficeCode}`;
    return `(${areaCode}) ${centralOfficeCode}-${lineNumber}`;
  };

  export const isEmptyDriver = (driver) => {
    if (driver == null || typeof driver !== 'object') {
      return true;
  }
    return Object.values(driver).every(value => value === null || value === false);
}

export const isEmpty = (value) => {
  if (value == null) return true; // Checks for null or undefined

  if (Array.isArray(value)) return value.length === 0; // Checks for empty array

  if (typeof value === 'object') return Object.keys(value).length === 0; // Checks for empty object

  return false; // Default case for other types (e.g., strings, numbers)
};


export const transformEmptyOrUndefinedToNull = (data) => {
  if (Array.isArray(data)) {
    return data.map(item => transformEmptyOrUndefinedToNull(item));
  } else if (typeof data === 'object' && data !== null) {
    if (Object.keys(data).length === 0) {
      return null; // Handle empty objects
    }
    return Object.keys(data).reduce((acc, key) => {
      acc[key] = transformEmptyOrUndefinedToNull(data[key]);
      return acc;
    }, {});
  } else {
    return (data === "" || data === undefined) ? null : data;
  }
};